@if (isLoading()) {
  <div class="loading-overlay">
    <qai-loading size="large" />
  </div>
} @else {
  <ng-content />
}
